module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="dashboard zmags-section wide">\n    <header class="title-field">\n        ' +
((__t = ( headerContentUnescaped )) == null ? '' : __t) +
'\n    </header>\n    <div class="dashboard-navigation-region"></div>\n</section>\n\n<div class="progress-indicator-region"></div>\n\n<footer class="default-footer"></footer>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/dashboard/DashboardView.tpl
// module id = 2901
// module chunks = 0